/**
 * What is left of the predecessor's chrome after the shell took the rest: the
 * one line a browser print shows.
 *
 * The top bar, the warning strip and the footer legend are gone — the rail, the
 * summary strip and the typed banners (`app/*`) replaced them. The language
 * toggle moved into Einstellungen, where a setting belongs.
 */
import { useT } from '../i18n';

/**
 * The only thing a browser print shows (@media print hides the app): the paper
 * form comes from the PDF button, not from the page. Rendered from React so it
 * follows the language, and mounted once at the app root.
 */
export function PrintNote() {
  const t = useT();
  return <div id="printnote">{t('print.note')}</div>;
}
